export default {
    allCategories(state) {
        return state.categories;
    },

    getCategorySelected(state) {
        return state.selected_category;
    },
};